import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=f93595bc&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=f93595bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93595bc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AirtableImage: require('/opt/build/repo/components/AirtableImage.vue').default,AppActionBar: require('/opt/build/repo/components/AppActionBar.vue').default,ProductGrid: require('/opt/build/repo/components/ProductGrid.vue').default})
